<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <transition leave-active-class="fadeOut" enter-active-class="fadeIn">
    <div class="modal is-active animated" v-if="open">
      <div class="modal-background" @click="$emit('close')"></div>
      <slot></slot>
    </div>
  </transition>
</template>

<style lang="scss">
  @import '~bulma/sass/utilities/all';

  .modal-card-title {
    flex: 1;
    padding-right: pxToEm(10);
    text-align: left;
  }

  @include mobile() {
    .modal {
      &-card {
        height: 100%;
        max-height: none;
        margin: 0;

        &-head,
        &-foot {
          border-radius: 0;
        }

        &-title {
          font-size: $font-size-m;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// ModalBase.vue?484cd304